/* eslint-disable @typescript-eslint/no-unused-vars */
import {NavigationEnd, Router, RouterLink, RouterLinkActive} from '@angular/router';
import {AsyncPipe, DOCUMENT, NgClass} from '@angular/common';
import {Component, ElementRef, HostListener, Inject, Input, OnDestroy, OnInit, Renderer2,} from '@angular/core';
import {AuthService} from '../../auth/auth.service';
import {FeatherModule} from 'angular-feather';
import {NgScrollbar} from 'ngx-scrollbar';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {AdminPipe} from "../../admin/admin.pipe";
import {Observable} from "rxjs";
import {MatBadgeModule} from "@angular/material/badge";
import {FeatherIconsComponent} from "@shared/components/feather-icons/feather-icons.component";
import {MatExpansionPanel, MatExpansionPanelDescription, MatExpansionPanelHeader, MatExpansionPanelTitle} from "@angular/material/expansion";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    MatButtonModule,
    MatIconModule,
    NgScrollbar,
    RouterLinkActive,
    NgClass,
    FeatherModule,
    AdminPipe,
    AsyncPipe,
    MatBadgeModule,
    AdminPipe,
    FeatherIconsComponent,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    MatExpansionPanelHeader
  ],
})
export class SidebarComponent implements OnInit, OnDestroy {
  public innerHeight?: number;
  public bodyTag!: HTMLElement;

  @Input() pendingCount!: Observable<number>;

  listMaxHeight?: string;
  listMaxWidth?: string;
  headerHeight = 60;
  routerObj;
  menuIcon = 'chevrons-left';

  private readonly overlayOpen = 'overlay-open';
  private readonly submenuClosed = 'submenu-closed';
  private readonly sideClosedHover = 'side-closed-hover';
  private readonly sideClosed = 'side-closed';

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly renderer: Renderer2,
    public elementRef: ElementRef,
    public authService: AuthService,
    private readonly router: Router,
  ) {
    this.elementRef.nativeElement.closest('body');
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // close sidebar on mobile screen after menu select
        this.renderer.removeClass(this.document.body, this.overlayOpen);
      }
    });
  }
  @HostListener('window:resize', ['$event'])
  windowResizecall() {
    this.setMenuHeight();
    this.checkStatuForResize();
  }
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, this.overlayOpen);
    }
  }
  callToggleMenu(event: Event, length: number) {
    if (length > 0) {
      const parentElement = (event.target as HTMLInputElement).closest('li');
      const activeClass = parentElement?.classList.contains('active');

      if (activeClass) {
        this.renderer.removeClass(parentElement, 'active');
      } else {
        this.renderer.addClass(parentElement, 'active');
      }
    }
  }
  ngOnInit() {
    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }
  ngOnDestroy() {
    this.routerObj.unsubscribe();
  }
  initLeftSidebar() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize();
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }
  isOpen() {
    return this.bodyTag.classList.contains(this.overlayOpen);
  }
  checkStatuForResize() {
    if (window.innerWidth < 1025) {
      this.renderer.addClass(this.document.body, 'ls-closed');
    } else {
      this.renderer.removeClass(this.document.body, 'ls-closed');
    }
  }

  mobileMenuSidebarOpen(event: Event, className: string) {
    const hasClass = (event.target as HTMLInputElement).classList.contains(
      className
    );
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }

  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains(this.sideClosed);
    if (hasClass) {
      this.renderer.removeClass(this.document.body, this.sideClosed);
      this.renderer.removeClass(this.document.body, this.submenuClosed);
      this.menuIcon = 'chevrons-left';
    } else {
      this.renderer.addClass(this.document.body, this.sideClosed);
      this.renderer.addClass(this.document.body, this.submenuClosed);
      this.menuIcon = 'chevrons-right';
    }

    const sideClosedHover =
      this.document.body.classList.contains(this.sideClosed);
    if (sideClosedHover) {
      this.renderer.removeClass(this.document.body, this.sideClosedHover);
    }
  }
  logout() {
    this.authService.logout().subscribe((res) => {
      if (!res.success) {
        this.router.navigate(['/auth/sign-in']);
      }
    });
  }
}
